import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

const CreateAccount = ({ booking, onCheckboxChange, variant = 'body2', sx = {} }) => {
    const { t } = useTranslation();

    return (
        <FormControlLabel
            sx={sx}
            control={
                <Checkbox
                    checked={booking.user.register}
                    onChange={onCheckboxChange}
                    name="user.register"
                    slotProps={{ input: { autoComplete: 'off' } }}
                />
            }
            label={<Typography variant={variant}>{t('booking.register')}</Typography>}
        />
    );
};

export { CreateAccount };
